import request from '@/utils/request'

// 查询北京鲁飞banner图列表
export function listBjlfbanner(query) {
  return request({
    url: '/system/bjlfbanner/list',
    method: 'get',
    params: query
  })
}

// 查询北京鲁飞banner图详细
export function getBjlfbanner(id) {
  return request({
    url: '/system/bjlfbanner/' + id,
    method: 'get'
  })
}

// 新增北京鲁飞banner图
export function addBjlfbanner(data) {
  return request({
    url: '/system/bjlfbanner',
    method: 'post',
    data: data
  })
}

// 修改北京鲁飞banner图
export function updateBjlfbanner(data) {
  return request({
    url: '/system/bjlfbanner',
    method: 'put',
    data: data
  })
}

// 删除北京鲁飞banner图
export function delBjlfbanner(id) {
  return request({
    url: '/system/bjlfbanner/' + id,
    method: 'delete'
  })
}
